import * as React from "react";
import PropTypes from 'prop-types';

const SvgTrashCan = props => {
  if (props.id !== "_svgtrashcan") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M29.032 31.61a.824.824 0 01-.838.84.824.824 0 01-.84-.84V18.192c0-.475.364-.838.84-.838.475 0 .838.363.838.838v13.42zm-1.845-18.032h-6.346v-1.621c0-.168.112-.28.28-.28h5.787c.167 0 .28.112.28.28v1.621zM24.84 31.611a.824.824 0 01-.839.838.824.824 0 01-.839-.838V18.19c0-.475.364-.838.839-.838s.839.363.839.838v13.42zm-4.194 0a.824.824 0 01-.839.838.824.824 0 01-.838-.838V18.19c0-.475.363-.838.838-.838.476 0 .84.363.84.838v13.42zm15.516-18.033h-7.324v-1.621c0-1.09-.867-1.957-1.957-1.957h-5.76c-1.09 0-1.957.867-1.957 1.957v1.621H11.84a.824.824 0 00-.839.84c0 .474.391.838.839.838h2.404l.643 18.731c.056 1.37 1.146 2.432 2.516 2.432h13.196c1.37 0 2.46-1.062 2.516-2.432l.643-18.731h2.404a.824.824 0 00.839-.839.824.824 0 00-.839-.839z" fill="#333" fillRule="evenodd" /></svg>;
};

SvgTrashCan.displayName = "_svgtrashcan";
SvgTrashCan.propTypes = {
  id: PropTypes.string
};
SvgTrashCan.defaultProps = {
  id: ''
};
export default SvgTrashCan;